import { SkyviewConfig } from '@optools/services/operator-gateway/types/generated/graphql';
import { Team } from '@optools/services/statsapi/types';
import { hydrateWithTeams } from '@optools/utils/teams';

export function groupSkyviewConfigsByTeam(configs: SkyviewConfig[], teams: Team[]) {
  const configsByTeamId = new Map<number, SkyviewConfig[]>();

  for (const config of configs) {
    const teamConfigs = configsByTeamId.get(config.teamId);
    if (teamConfigs) {
      teamConfigs.push(config);
    } else {
      configsByTeamId.set(config.teamId, [config]);
    }
  }

  const groupedConfigs = Array.from(configsByTeamId, ([teamId, configs]) => ({
    configs,
    teamId,
  }));

  return hydrateWithTeams(groupedConfigs, teams);
}
